import { createIdentifier } from '@blocksuite/global/di';
import type { ExtensionType } from '@blocksuite/store';
import { BehaviorSubject } from 'rxjs';

/**
 * Where the editor took the reader on request (a link, a search hit, the AI):
 * the blocks or canvas elements of the navigation, once they are in view.
 * `kind` says how the request named them: blocks of the document, or elements
 * of the canvas. Cleared when the next navigation starts or the reader takes
 * the hand. The workspace context reads it to confirm a navigation arrived.
 */
export interface NavigationAnchor {
  kind: 'block' | 'canvas-element';
  ids: readonly string[];
}

export const NavigationAnchorService = createIdentifier<
  BehaviorSubject<NavigationAnchor | null>
>('NavigationAnchorService');

export const NavigationAnchorServiceExtension: ExtensionType = {
  setup: di => {
    di.addImpl(
      NavigationAnchorService,
      () => new BehaviorSubject<NavigationAnchor | null>(null)
    );
  },
};
